/* ============================================================================
   RDG — LES RECOMMANDATIONS DU TIROIR PANIER (28/08/2026)
   ----------------------------------------------------------------------------
   Remplit la bande « Recommandé pour vous » du tiroir panier, en récupérant le
   HTML rendu par sections/rdg-reco-panier.liquid via l'API de recommandations
   de Shopify.

   POURQUOI CE N'EST PAS RENDU CÔTÉ SERVEUR AVEC LE RESTE DU TIROIR
   L'objet Liquid `recommendations` n'est rempli que sur l'URL
   /recommendations/products. Dans une section ordinaire il est vide : il faut
   donc un aller-retour, et c'est le fonctionnement prévu par Shopify.

   L'AMORCE EST LE PREMIER ARTICLE DU PANIER. Un panier n'a pas de « produit
   courant » ; il fallait choisir. Le premier article est celui qui a déclenché
   l'achat, c'est le meilleur point de départ disponible sans inventer une
   moyenne qui ne voudrait rien dire.

   ON NE REFAIT PAS L'APPEL À CHAQUE CHANGEMENT DE PANIER. Le tiroir se
   re-rend à chaque changement de quantité ; refaire une requête réseau à
   chaque « + » serait absurde. On ne rappelle que si l'AMORCE a changé, et le
   résultat est gardé en mémoire pour la durée de la page.
   ========================================================================= */

(function () {
  'use strict';

  var CONTENEUR = '[data-rdg-reco]';
  var SECTION = 'rdg-reco-panier';
  var LIMITE = 10;

  var cache = {};          /* amorce -> promesse de HTML */
  var derniereAmorce = null;

  function racineRoutes() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function conteneur() {
    return document.querySelector(CONTENEUR);
  }

  function tiroirOuvert() {
    var d = document.getElementById('CartDrawer');
    return !!(d && d.open);
  }

  /* L'amorce est lue sur le DOM du tiroir et non sur /cart.js : le premier
     article y est déjà, et une requête de moins est une requête de moins. Le
     bloc « Complétez votre look » porte justement l'id du premier produit du
     panier dans `data-id` — on s'en sert plutôt que d'en poser un deuxième. */
  function amorce() {
    var c = document.querySelector('[id$="-complementary"][data-id]');
    var id = c && c.getAttribute('data-id');
    return id && id !== '' ? id : null;
  }

  function chercher(id) {
    if (cache[id]) return cache[id];
    var url = racineRoutes() + 'recommendations/products'
      + '?section_id=' + encodeURIComponent(SECTION)
      + '&product_id=' + encodeURIComponent(id)
      + '&limit=' + LIMITE
      + '&intent=related';

    cache[id] = fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        /* La réponse est la section entière, enveloppée par Shopify dans un
           conteneur. On ne garde que l'intérieur — sinon on emboîterait une
           section dans notre bloc à chaque appel. */
        var hote = document.createElement('div');
        hote.innerHTML = html;
        var section = hote.querySelector('.shopify-section') || hote;
        return section.innerHTML.trim();
      })
      ['catch'](function () { return ''; });

    return cache[id];
  }

  /* L'indicateur de défilement. Écrit au fil du doigt : largeur du curseur
     proportionnelle à la part visible, position proportionnelle au défilement.
     Rien de tout cela n'est faisable en CSS seul. */
  function brancherRail(bloc) {
    var piste = bloc.querySelector('[data-rdg-reco-piste]');
    var rail = bloc.querySelector('[data-rdg-reco-rail]');
    var curseur = bloc.querySelector('[data-rdg-reco-curseur]');
    if (!piste || !rail || !curseur) return;

    function majRail() {
      var total = piste.scrollWidth;
      var vu = piste.clientWidth;

      /* LARGEUR NULLE = ON NE CONCLUT RIEN, et c'est le correctif du 28/08.
         Le bloc est injecté pendant que le <dialog> est encore FERMÉ : un
         élément dans un dialogue fermé n'est pas mis en page, ses deux
         mesures valent 0, et `0 <= 0 + 1` faisait conclure « rien ne
         déborde ». Le rail était masqué une fois pour toutes, alors que la
         bande déborde de plus de quatre écrans.
         Mesuré en production : rail masqué, `defilable: true` juste à côté —
         les deux vérités venant de deux instants différents. Sortir sans
         RIEN décider est la seule réponse honnête à une mesure impossible. */
      if (vu === 0) return;

      if (total <= vu + 1) { rail.hidden = true; return; }
      rail.hidden = false;
      var part = vu / total;
      var avance = piste.scrollLeft / (total - vu);
      curseur.style.width = (part * 100) + '%';
      /* `avance` est borné : un défilement élastique (iOS) sort de [0,1] et
         pousserait le curseur hors de son rail. */
      var borne = Math.max(0, Math.min(1, avance));
      curseur.style.transform = 'translateX(' + (borne * (100 / part - 100)) + '%)';
    }

    piste.addEventListener('scroll', majRail, { passive: true });

    /* La largeur d'un tiroir change avec l'écran : l'observateur rattrape les
       rotations et les changements de taille. */
    if (window.ResizeObserver) {
      try { new ResizeObserver(majRail).observe(piste); } catch (e) {}
    }

    /* ET SURTOUT : ON RECALCULE QUAND CHAQUE IMAGE ARRIVE.
       Mesuré le 28/08 en production — au premier appel, les <img> n'ont pas
       encore de hauteur : la piste ne déborde donc pas, `majRail` conclut
       « rien à faire défiler » et masque le rail. Il ne réapparaissait jamais.

       Ne PAS s'en remettre au seul ResizeObserver pour ce cas : il est
       programmé sur la boucle d'animation, qui ne tourne pas dans un onglet
       masqué (une page ouverte en arrière-plan, un volet d'aperçu). Le rail y
       resterait faux jusqu'au premier défilement — c'est-à-dire jusqu'au geste
       qu'il est censé annoncer. L'événement `load` d'une image, lui, arrive
       quoi qu'il arrive. */
    Array.prototype.forEach.call(piste.querySelectorAll('img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', majRail, { once: true });
      img.addEventListener('error', majRail, { once: true });
    });

    majRail();

    /* On garde la fonction accessible depuis l'extérieur : c'est l'ouverture
       du tiroir qui donne enfin une largeur à mesurer, et elle est pilotée
       ailleurs (voir le déclencheur en bas de fichier). */
    bloc.__rdgMajRail = majRail;
  }

  /* La vue est annoncee ICI, et a chaque fois que la bande finit VISIBLE —
     pas seulement quand elle vient d'etre construite. Une bande deja en cache
     qu'on remontre est vue une seconde fois ; ne compter que les constructions
     aurait mesure le travail du script, pas ce que la cliente a sous les yeux. */
  function annoncerVue(bloc) {
    try {
      document.dispatchEvent(new CustomEvent('rdg:reco-affichee', {
        detail: { nombre: bloc.querySelectorAll('.rdg-reco__carte').length }
      }));
    } catch (e) {}
  }

  /* ------------------------------------------------------------------ */
  /* ON NE PROPOSE PAS DEUX FOIS LE MEME ARTICLE (29/08/2026)             */
  /*                                                                     */
  /* Lucien, capture a l'appui : PANTALON RAYMONDE occupait « Completez   */
  /* votre look » ET la premiere carte de « Recommande pour vous », l'un  */
  /* sous l'autre. Deux blocs qui se suivent et qui montrent la meme      */
  /* piece : la bande perd la moitie de sa raison d'etre, et la liste     */
  /* parait plus courte qu'elle n'est.                                    */
  /*                                                                     */
  /* ON LIT CE QUI EST REELLEMENT AFFICHE, pas ce qui devrait l'etre.     */
  /* « Completez votre look » a DEUX sources possibles selon un reglage   */
  /* de section (le metachamp de Search & Discovery, ou une liste posee a */
  /* la main) : les deviner en Liquid depuis cette section-ci demanderait */
  /* de relire les reglages d'une AUTRE section, qu'on n'a pas. Lire les  */
  /* liens presents dans le DOM couvre les deux cas sans rien supposer.   */
  /*                                                                     */
  /* LES ARTICLES DEJA AU PANIER SONT EXCLUS AUSSI, pour la meme raison : */
  /* recommander ce qu'elle vient d'ajouter n'apprend rien.                */
  /* ------------------------------------------------------------------ */
  function handleDepuisLien(a) {
    var h = a.getAttribute('href') || '';
    var m = h.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function dejaMontres() {
    var vus = {};
    var zones = [
      '[id$="-complementary"]',      /* « Completez votre look » */
      '#CartDrawer-CartItems'        /* les articles du panier   */
    ];
    zones.forEach(function (sel) {
      var z = document.querySelector(sel);
      if (!z) return;
      Array.prototype.forEach.call(z.querySelectorAll('a[href*="/products/"]'), function (a) {
        var h = handleDepuisLien(a);
        if (h) vus[h] = true;
      });
    });
    return vus;
  }

  function retirerLesDoublons(bloc) {
    var vus = dejaMontres();
    var retires = 0;
    Array.prototype.forEach.call(bloc.querySelectorAll('.rdg-reco__carte'), function (carte) {
      var a = carte.querySelector('a[href*="/products/"]');
      var h = a && handleDepuisLien(a);
      if (h && vus[h]) { carte.parentNode.removeChild(carte); retires++; }
    });
    return retires;
  }

  function dessiner() {
    var bloc = conteneur();
    if (!bloc) return;

    var id = amorce();
    if (!id) { bloc.hidden = true; return; }
    if (id === derniereAmorce && bloc.innerHTML.trim() !== '') {
      /* ON REPASSE LE FILTRE, meme sur une bande deja construite : entre deux
         ouvertures du tiroir, un article a pu rejoindre le panier. Sans cela on
         recommanderait une piece que la cliente vient d'ajouter — exactement le
         doublon qu'on corrige, avec un tour de retard. */
      retirerLesDoublons(bloc);
      if (!bloc.querySelectorAll('.rdg-reco__carte').length) {
        bloc.hidden = true;
        return;
      }
      bloc.hidden = false;
      annoncerVue(bloc);
      return;
    }

    chercher(id).then(function (html) {
      var encore = conteneur();
      if (!encore) return;
      /* L'amorce a pu changer pendant la requête (article retiré, tiroir
         rouvert) : on n'écrase pas un résultat plus récent par un plus ancien.
         Même garde que dans rdg-wishlist.js, pour la même raison. */
      if (amorce() !== id) return;

      derniereAmorce = id;
      encore.innerHTML = html;
      /* VIDE = ON MASQUE TOUT, titre compris. La section ne rend rien quand
         Shopify n'a aucune recommandation à donner ; laisser le conteneur
         ouvert afficherait une réserve vide au milieu du tiroir. */
      encore.hidden = html === '';
      if (html !== '') {
        retirerLesDoublons(encore);
        /* Tout retire = plus rien a montrer. On masque le bloc, titre compris :
           un intitule « Recommande pour vous » au-dessus du vide est pire que
           pas de bande du tout. */
        if (!encore.querySelectorAll('.rdg-reco__carte').length) {
          encore.hidden = true;
          return;
        }
        brancherRail(encore);
        annoncerVue(encore);
      }
    });
  }

  /* Le tiroir se remplit à l'ouverture. Même déclencheur que le tiroir des
     coups de cœur : le clic sur ce qui l'ouvre, en phase de capture, plutôt
     qu'un observateur permanent sur le DOM. */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest
      ? ev.target.closest('[aria-controls="CartDrawer"]')
      : null;
    if (!t) return;
    setTimeout(dessiner, 0);
    /* ET ON REMESURE UNE FOIS LE TIROIR OUVERT. L'animation d'entrée dure
       720ms (rdg-motion.js) ; avant sa fin, la piste n'a pas sa largeur
       définitive. 900ms laisse la marge, et c'est un seul calcul de
       géométrie — pas une requête. Deux passes valent mieux qu'un rail faux :
       la première sert au cas déjà en cache, la seconde au cas général. */
    setTimeout(function () {
      var b = conteneur();
      if (b && typeof b.__rdgMajRail === 'function') b.__rdgMajRail();
    }, 900);
  }, true);

  /* Et à chaque mise à jour du panier : si le premier article a changé (le
     seul cas qui compte), l'amorce change et la bande se refait. Sinon
     `dessiner` sort tout de suite sans toucher au réseau. */
  /* ⚠️ ON NE DESSINE RIEN TANT QUE LE TIROIR N'EST PAS OUVERT.
     La premiere version appelait `dessiner()` au chargement de la page. Deux
     defauts, mesures le 28/08 juste apres la mise en ligne :
       1. une requete vers /recommendations sur CHAQUE page, pour une bande que
          la plupart des visiteuses n'ouvriront jamais ;
       2. et surtout une VUE annoncee au tracker alors que personne n'avait vu
          quoi que ce soit — exactement le compteur menteur que cet evenement
          etait cense empecher.
     C'est la meme regle que le tiroir des coups de cœur, ou elle etait ecrite
     depuis le debut : « il ne coute aucune requete tant qu'on ne l'ouvre pas ».
     Je ne l'avais pas reportee ici. */
  document.addEventListener('cart:update', function () {
    if (tiroirOuvert()) dessiner();
  });
  document.addEventListener('rdg:add-to-cart', function () {
    /* ⚠ ON ATTEND LA FIN DE L'ANIMATION D'ENTREE, PAS UN DELAI FIXE.
       Mesure du 02/09 dans un vrai navigateur, releve toutes les 200ms :
         800ms  le tiroir s'ouvre (classe `dialog-opening`)
         1000ms LA BANDE S'INJECTE — la zone passe de 500/500 a 500/598
         1600ms `dialog-opening` est enfin retiree
       Le contenu grandissait donc de 98px SOUS LE DOIGT, en pleine animation.
       C'etait la seule asymetrie du fichier entre les deux chemins : celui du
       clic (plus bas) attend et remesure a 900ms, celui de l'ajout dessinait
       a 600ms et ne remesurait jamais. Elle correspond au defaut signale par
       Lucien le 02/09 — « a la premiere ouverture le panier est fige ; une
       fois ressorti, ou si le panier contenait deja des articles, non ».

       On ne remplace pas 600 par un nombre plus grand : un delai fixe reste
       un pari sur la vitesse de l'appareil. On attend l'etat reel — tiroir
       ouvert ET animation terminee — avec un plafond de 3s pour ne jamais
       rester suspendu. */
    var essais = 0;
    var lancee = false;
    (function attendreLaFinDeLAnimation() {
      var d = document.getElementById('CartDrawer');
      /* ON RECHAUFFE LE RESEAU DES QUE LE TIROIR EST OUVERT, sans attendre la
         fin de l'animation. Lucien, 02/09 : « le tiroir reste figé 2 s, après
         on peut scroller » — ces 2 s, c'etaient l'animation PUIS la requete,
         l'une apres l'autre. `chercher()` memorise sa promesse par identifiant
         (voir plus haut) : l'appeler ici ne fait que demarrer le telechargement,
         et le `dessiner()` ci-dessous reutilisera la meme promesse au lieu d'en
         ouvrir une seconde. Les deux attentes se recouvrent donc au lieu de
         s'additionner, et la bande se pose des la fin de l'animation.
         On ne dessine toujours RIEN avant cette fin : c'est elle qui evitait
         que le contenu grandisse sous le doigt. */
      if (!lancee && tiroirOuvert()) {
        var amorceTot = amorce();
        if (amorceTot) { lancee = true; chercher(amorceTot); }
      }
      if (tiroirOuvert() && d && !d.classList.contains('dialog-opening')) {
        dessiner();
        /* Meme seconde passe que le chemin du clic : la piste n'a sa largeur
           definitive qu'une fois le contenu pose. */
        setTimeout(function () {
          var b = conteneur();
          if (b && typeof b.__rdgMajRail === 'function') b.__rdgMajRail();
        }, 500);
        return;
      }
      if (++essais < 30) setTimeout(attendreLaFinDeLAnimation, 100);
    })();
  });
})();
